import React from 'react'; 
import PropTypes from 'prop-types';
//Components
import AddressToString from '../AddressToString';

const AddressInfo = ({address}) => {
    return (
            <strong>
                <AddressToString {...address} />
            </strong>
    );
};

AddressInfo.propTypes = {
    address: PropTypes.object,
};
export default AddressInfo;